import type { BrandKit } from '../brand.types'
import { primary, secondary } from '@/styles/palette'
import logo from '@/assets/brands/aqua-vitae/logo.svg'
import favicon from '@/assets/brands/aqua-vitae/favicon.svg'

/**
 * AquaVitae — the standalone mark and the teal/green palette already defined
 * in `styles/palette.ts`.
 *
 * The brand kit ships no reverse (white) mark, and the guide forbids
 * recolouring one, so on the teal brand surface the mark sits on a white
 * plate instead.
 */
export const aquaVitaeBrand: BrandKit = {
  id: 'aqua-vitae',
  name: 'AquaVitae',

  logo,
  logoOnBrand: logo,
  logoOnBrandPlate: true,
  favicon,

  palette: {
    primary: {
      main: primary.main,
      dark: primary.dark,
      light: primary.light,
      lighter: primary[30],
      contrastText: primary.contrastText,
    },
    secondary: {
      main: secondary.main,
      dark: secondary.dark,
      light: secondary.light,
      lighter: secondary[30],
      contrastText: secondary.contrastText,
    },
  },

  brandSurface: `linear-gradient(135deg, ${primary.dark} 0%, ${primary.main} 100%)`,
}
